module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [_c('div', {
    staticClass: "goods-type-title"
  }, [_c('div', {
    staticClass: "goods-type-title-left"
  }, [_c('div', {
    staticClass: "left-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showTab) ? _c('div', {
    staticClass: "right-sub"
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "right-sub-item",
      class: _vm.active == item.key ? 'activeSty' : '',
      on: {
        "click": function($event) {
          return _vm.activeType(item.key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('list', {
    attrs: {
      "type": _vm.active,
      "num": _vm.numMax,
      "isShowBg": _vm.isShowBg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec5d536"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/perference-sale/index.vue
// module id = 1546
// module chunks = 1